const LOCAL_COMBINATION_NEWS_VIEWED_KEY = "localCombinationNewsViewed";

export function hasViewedLocalCombinationNews(): boolean {
  return localStorage.getItem(LOCAL_COMBINATION_NEWS_VIEWED_KEY) === "true";
}

export function setViewedLocalCombinationNews(viewed: boolean): void {
  localStorage.setItem(
    LOCAL_COMBINATION_NEWS_VIEWED_KEY,
    viewed ? "true" : "false"
  );
}
